
import {Component, Vue} from 'vue-property-decorator';
import ClienteViewComponent from "@/components/ClienteViewComponent.vue"

@Component({
  name: "ClienteEdit",
  components: {
    ClienteViewComponent
  }
})
export default class ClienteEdit extends Vue {
}
